import React, { useState, useEffect, ChangeEvent, FormEvent } from 'react';
import { changePassword } from '../../types/ChangePassword';
import { Container, Form, Button, Card, Alert, Toast } from 'react-bootstrap';
import { useOktaAuth } from '@okta/okta-react';
import { AxiosError, AxiosResponse } from 'axios';
import { useNavigate } from 'react-router-dom';
import config from '../../Config';

import '../../assets/css/okta-sign-in.min.css';
import '../../assets/css/ChangePasswordCustom.css';

import originLogoAndText from '../../assets/img/origin-icon-and-text.svg';

import OktaService from '../../services/OktaService';

const ChangePassword: React.FC = () => {
    const navigate = useNavigate();
    const [showToast, setShowToast] = useState(false);
    const { oktaAuth, authState } = useOktaAuth();
    const [error, setError] = useState<AxiosError>();
    const [isError, setIsError] = useState(false);
    const [response, setResponse] = useState<AxiosResponse>();
    const [loading, setLoading] = useState(true);
    const [validated, setValidated] = useState(false);
    const [show, setShow] = useState(true);
    const [isPost, setPost] = useState(false);
    const initialchangePassword: changePassword = {
        uId: '',
        currentPassword: '',
        newPassword: '',
    };
    const [passwordChange, setPasswordChange] = useState<changePassword>(initialchangePassword);
    const [confirmPassword, setConfirmPassword] = useState('');

    const axiosConfig: any = config.userApi.config;
    const [userInfo, setUserInfo] = useState<any>(null);

    // local members
    var uid: string = '';
    var token: string = '';
    if (authState.isAuthenticated) {
        uid = authState.accessToken.claims?.uid;
        token = authState.accessToken.accessToken;
    } else {
        // How to get this in the error Boundary???
        throw new Error('User Unauthorized');
    }

    //private functions
    function UpdatePassword() {
        OktaService.changePwd(uid, passwordChange, token)
            .then((response) => {
                setResponse(response);
                setLoading(false);
                setShowToast(true);
                setTimeout(() => {
                    oktaAuth.signOut();
                }, 3000);
            })
            .catch((ex) => {
                setError(ex);
                setIsError(true);
                setLoading(false);
            });
    }

    //Events

    const onChange = (e: ChangeEvent<HTMLInputElement>) => {
        // very very hard to set state for a nested object
        e.persist();
        var rpc = { ...passwordChange };
        switch (e.target.name) {
            case 'oldpassword':
                rpc.currentPassword = e.target.value;
                break;
            case 'newpassword':
                rpc.newPassword = e.target.value;

                break;
            case 'reenterpassword':
                setConfirmPassword(e.target.value);

                break;
        }
        setPasswordChange(rpc);
    };

    const handleClose = () => {
        //oktaAuth.signOut();
    };

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError(undefined);
        setResponse(undefined);
        setIsError(false);
        const form = e.currentTarget;
        setValidated(true);
        setShow(true);
        setLoading(false);
        if (form.checkValidity()) {
            if (passwordChange.newPassword.length > 0 && confirmPassword.length > 0) {
                if (passwordChange.newPassword != confirmPassword) {
                    setShow(true);
                    setValidated(false);
                    setPost(true);
                } else {
                    setShow(false);
                    setPost(true);
                    setValidated(true);
                    UpdatePassword();
                }
            }
        }
    };

    return (
        <>
            {!loading && isError && error && (
                <Alert variant='danger'>{JSON.stringify(error.response?.data)}</Alert>
            )}
            {!validated && show && isPost && !loading && (
                <Alert variant='danger'>Passwords dont Match</Alert>
            )}

            {!loading && !isError && validated && isPost && (
                <div className='row justify-content-center'>
                    <Toast show={showToast} onClose={handleClose} delay={3000} autohide>
                        <Toast.Header closeButton={false}>Password Changed!</Toast.Header>
                        <Toast.Body>
                            You are now being logged out ... Please login again with your new
                            password
                        </Toast.Body>
                    </Toast>
                </div>
            )}

            <div className='password-container'>
                <div className='logo-container'>
                    <img src={originLogoAndText} alt='company logo' height='90px'></img>
                </div>
                <div
                    data-se='auth-container'
                    id='okta-sign-in'
                    className='auth-container main-container no-beacon'
                >
                    <div className='auth-content'>
                        <div className='auth-content-inner'>
                            <div className='primary-auth'>
                                <Form
                                    onSubmit={handleSubmit}
                                    noValidate
                                    validated={validated}
                                    data-se='o-form'
                                    slot='content'
                                    id='form1'
                                    className='primary-auth-form o-form o-form-edit-mode'
                                >
                                    <Form.Group>
                                        <div
                                            data-se='o-form-content'
                                            className='o-form-content o-form-theme clearfix'
                                        >
                                            <h2
                                                data-se='o-form-head'
                                                className='okta-form-title o-form-head'
                                            >
                                                Change Password
                                            </h2>

                                            <div
                                                className='o-form-fieldset-container'
                                                data-se='o-form-fieldset-container'
                                            >
                                                <div
                                                    data-se='o-form-fieldset'
                                                    className='o-form-fieldset o-form-label-top margin-btm-5'
                                                >
                                                    <div
                                                        data-se='o-form-input-container'
                                                        className='o-form-input'
                                                    >
                                                        <Form.Control
                                                            type='Password'
                                                            className='o-form-input-name-password o-form-control okta-form-input-field input-fix'
                                                            placeholder='Enter Current password'
                                                            size='sm'
                                                            required
                                                            name='oldpassword'
                                                            onChange={onChange}
                                                        />
                                                        <Form.Control.Feedback type='invalid'>
                                                            Please enter your current password
                                                        </Form.Control.Feedback>
                                                    </div>
                                                </div>

                                                <div
                                                    data-se='o-form-fieldset'
                                                    className='o-form-fieldset o-form-label-top margin-btm-5'
                                                >
                                                    <div
                                                        data-se='o-form-input-container'
                                                        className='o-form-input'
                                                    >
                                                        <Form.Control
                                                            type='Password'
                                                            className='o-form-input-name-password o-form-control okta-form-input-field input-fix'
                                                            placeholder='Enter New Password'
                                                            size='sm'
                                                            required
                                                            name='newpassword'
                                                            onChange={onChange}
                                                        />
                                                        <Form.Control.Feedback type='invalid'>
                                                            Please enter your new password
                                                        </Form.Control.Feedback>
                                                    </div>
                                                </div>

                                                <div
                                                    data-se='o-form-fieldset'
                                                    className='o-form-fieldset o-form-label-top margin-btm-30'
                                                >
                                                    <div
                                                        data-se='o-form-input-container'
                                                        className='o-form-input'
                                                    >
                                                        <Form.Control
                                                            type='Password'
                                                            className='o-form-input-name-password o-form-control okta-form-input-field input-fix'
                                                            placeholder='Re-Enter New Password'
                                                            size='sm'
                                                            required
                                                            name='reenterpassword'
                                                            onChange={onChange}
                                                        />
                                                        <Form.Control.Feedback type='invalid'>
                                                            Please re enter your new password
                                                        </Form.Control.Feedback>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='o-form-button-bar'>
                                            <input
                                                className='button button-primary'
                                                type='submit'
                                                value='Change Password'
                                                id='okta-signin-submit'
                                                data-type='save'
                                            />
                                        </div>
                                        <div className='o-form-button-bar'>
                                            <input
                                                className='button button-secondary'
                                                type='button'
                                                value='Cancel'
                                                id='cancel'
                                                onClick={() => {
                                                    navigate('/');
                                                }}
                                            />
                                        </div>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ChangePassword;
